const DonationActionTypes = {
    UPDATE_COLLECTIONS: 'UPDATE_COLLECTIONS'
}

export default DonationActionTypes;